export var DiscountType;
(function (DiscountType) {
    DiscountType["Dollars"] = "Dollars";
    DiscountType["Percentage"] = "Percentage";
})(DiscountType || (DiscountType = {}));
export var DiscountScope;
(function (DiscountScope) {
    DiscountScope["FullOrder"] = "FullOrder";
    DiscountScope["PerTicketAllRates"] = "PerTicketAllRates";
    DiscountScope["PerTicketSpecificRates"] = "PerTicketSpecificRates";
})(DiscountScope || (DiscountScope = {}));
export var MembershipValidityPeriod;
(function (MembershipValidityPeriod) {
    MembershipValidityPeriod["OneYearAfterPayment"] = "OneYearAfterPayment";
    MembershipValidityPeriod["AtDate"] = "AtDate";
    MembershipValidityPeriod["NoExpiration"] = "NoExpiration";
    MembershipValidityPeriod["OneMonthAfterPayment"] = "OneMonthAfterPayment";
    MembershipValidityPeriod["CustomDuration"] = "CustomDuration";
})(MembershipValidityPeriod || (MembershipValidityPeriod = {}));
export var TicketingFormCategory;
(function (TicketingFormCategory) {
    TicketingFormCategory["Event"] = "Event";
    TicketingFormCategory["MembershipV2"] = "MembershipV2";
    TicketingFormCategory["Lottery"] = "Lottery";
    TicketingFormCategory["Sweepstakes"] = "Sweepstakes";
    TicketingFormCategory["Shop"] = "Shop";
    TicketingFormCategory["Auction"] = "Auction";
    TicketingFormCategory["Custom"] = "Custom";
})(TicketingFormCategory || (TicketingFormCategory = {}));
export const LinkedP2PTicketingCategory = TicketingFormCategory.Event;
export var ShopVariantType;
(function (ShopVariantType) {
    ShopVariantType["Size"] = "Size";
    ShopVariantType["Color"] = "Color";
    ShopVariantType["Custom"] = "Custom";
})(ShopVariantType || (ShopVariantType = {}));
export var Column;
(function (Column) {
    Column["Fields"] = "fields";
    Column["Translations"] = "translations";
})(Column || (Column = {}));
